import React, { useState } from 'react';
import ProductCard from '../common/ProductCard';

/**
 * ProductTabs - Component for product tabs (New Arrival, Bestseller, Featured)
 * Follows React Rules: Uses hooks properly, pure render logic
 * 
 * @param {Object} products - Object with tab names as keys and product arrays as values
 * @param {Function} onAddToCart - Callback for add to cart
 * @param {Function} onAddToWishlist - Callback for wishlist
 * @param {Function} onQuickView - Callback for quick view
 */
const ProductTabs = ({
  products = {},
  onAddToCart,
  onAddToWishlist,
  onQuickView
}) => {
  const [activeTab, setActiveTab] = useState('new');

  const tabs = [
    { id: 'new', label: 'New Arrival', key: 'newArrival' },
    { id: 'bestseller', label: 'Bestseller', key: 'bestseller' },
    { id: 'featured', label: 'Featured Products', key: 'featured' }
  ];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const activeTabData = tabs.find(tab => tab.id === activeTab);
  const activeProducts = activeTabData 
    ? products[activeTabData.key] || [] 
    : [];

  return (
    <div className="product-area pt-60 pb-50">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="li-product-tab">
              <ul className="nav li-product-menu">
                {tabs.map(tab => (
                  <li key={tab.id}>
                    <a
                      className={activeTab === tab.id ? 'active' : ''}
                      href={`#li-${tab.id}-product`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleTabChange(tab.id);
                      }}
                    >
                      <span>{tab.label}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="tab-content">
          {tabs.map(tab => {
            const tabProducts = products[tab.key] || [];
            return (
              <div
                key={tab.id}
                id={`li-${tab.id}-product`}
                className={`tab-pane ${activeTab === tab.id ? 'active show' : ''}`}
                role="tabpanel"
              >
                <div className="row">
                  <div className="product-active owl-carousel" data-react-carousel="true">
                    {tabProducts.map((product) => (
                      <div key={product.id} className="col-lg-12">
                        <ProductCard
                          product={product}
                          onAddToCart={onAddToCart}
                          onAddToWishlist={onAddToWishlist}
                          onQuickView={onQuickView}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductTabs;

